import React from 'react';
import Navbar from './components/Navbar';
import SocialRail from './components/SocialRail';
import Home from './pages/Home';

export default function App() {
  return (
    <>
      <Navbar />
      <SocialRail />
      <Home />
    </>
  );
}
